import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { DELETE_STORE, GET_STORES } from "./actionType";

import {
  apiResponseError,
  apiResponseSuccess,
  deleteStoreFail,
  deleteStoreSuccess,
} from "./action";
import { deleteStore, getStoresApi } from "../../helpers/store_helper";

function* getStores({ payload: params }) {
  try {
    const response = yield call(getStoresApi, { params: params });
    yield put(apiResponseSuccess(GET_STORES, response));
  } catch (error) {
    yield put(apiResponseError(GET_STORES, error));
  }
}

function* deleteStores({ payload: product }) {
  try {
    const response = yield call(deleteStore, product);
    // console.log("response", response);
    yield put(deleteStoreSuccess(response));
  } catch (error) {
    yield put(deleteStoreFail(error));
  }
}

export function* watchGetStores() {
  yield takeEvery(GET_STORES, getStores);
}

export function* watchDeleteStores() {
  yield takeEvery(DELETE_STORE, deleteStores);
}

function* storeSaga() {
  yield all([fork(watchGetStores), fork(watchDeleteStores)]);
}

export default storeSaga;
